import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';

interface ToastProps {
  message: string;
  type?: 'success' | 'danger' | 'warning' | 'info';
  isOpen: boolean;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'danger', 
  isOpen, 
  onClose,
  duration = 5000 
}) => {
  useEffect(() => {
    if (isOpen && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  const iconMap = {
    success: 'ri-checkbox-circle-line',
    danger: 'ri-error-warning-line',
    warning: 'ri-alert-line',
    info: 'ri-information-line',
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '400px',
        minWidth: '300px',
        animation: 'slideInRight 0.3s ease-out',
      }}
    >
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          @keyframes slideOutRight {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `}
      </style>
      <Alert 
        color={type} 
        toggle={onClose}
        className="mb-0 shadow-lg"
        style={{
          border: 'none',
          borderLeft: `4px solid ${
            type === 'danger' ? '#ef4444' :
            type === 'success' ? '#10b981' :
            type === 'warning' ? '#f59e0b' :
            '#3b82f6'
          }`,
        }}
      >
        <div className="d-flex align-items-start">
          <i className={`${iconMap[type]} fs-4 me-2 mt-1`}></i>
          <div className="flex-grow-1">
            <strong className="d-block mb-1">
              {type === 'danger' ? 'Error' :
               type === 'success' ? 'Success' :
               type === 'warning' ? 'Warning' :
               'Info'}
            </strong>
            <span>{message}</span>
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default Toast;
